import omit from 'lodash/omit';
import React from 'react';
import { BaseFieldProps } from '../types';
import { getBankIconURL } from './getBankIconURL';
import { Bank } from './types';
import { BankDropdownView } from './view';

interface BankDropdownControllerProps extends BaseFieldProps {
  bankList: {
    id: string;
    name: string;
  }[];
  placeholder?: string;
}

interface BankDropdownControllerState {
  items: Bank[];
}

export class BankDropdownController extends React.Component<
  BankDropdownControllerProps,
  BankDropdownControllerState
> {
  handleSelect = ({ id }: any) => {
    this.props.onChange({
      value: id,
      name: this.props.name,
      isValid: true,
    });
  };

  render() {
    const passedProps = omit(this.props, ['onChange', 'touched', 'type']);

    return (
      <BankDropdownView
        {...passedProps}
        bankList={this.props.bankList.map(({ id, name }) => ({
          id,
          label: name,
          value: id,
          icon: getBankIconURL(id),
        }))}
        value={this.props.value || ''}
        isError={!this.props.isValid && this.props.touched}
        onSelect={this.handleSelect}
      />
    );
  }
}
